import * as Sentry from "@sentry/react";

import { isExpectedLoginError } from "./login";

type IgnorableSentryErrorMatcher = (
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint,
) => boolean;

const IGNORABLE_SENTRY_ERROR_MATCHERS: IgnorableSentryErrorMatcher[] = [
  isExpectedLoginError,
];

export function isIgnorableSentryError(
  event: Sentry.ErrorEvent,
  hint: Sentry.EventHint,
): boolean {
  return IGNORABLE_SENTRY_ERROR_MATCHERS.some((matcher) =>
    matcher(event, hint),
  );
}
